import React, { useEffect } from "react";
import "./styled.css";
//redux
import { connect } from "react-redux";
//tags
import MetaTags from "react-meta-tags";

function TalentBrandStore(props) {
  function openLink(link) {
    window.open(link, "_blank");
  }

  useEffect(() => {
    document.getElementById("title-talent").focus();
    props.loadingUserOff();
  }, []);

  return (
    <section className="section-talent" id="section-mainStage">
      <MetaTags>
        <title>Digital Lovers Festival - Página Talent Brand Store</title>
      </MetaTags>
      <a id="title-talent" className="title-home" tabIndex={12}>
        Página Talent Brand Store
      </a>
      <div className="div-cards-talent">
        {/* <div className="card-talent">
          <a className="title-card-talent" id="title-card-talent" tabIndex={13}>
            Telent Brand Store
          </a>
          <video width={250} controls tabIndex={14}>
            <source src="https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/TALENT%20BRAND%20STORE/Talent%20Brand%20Store.mp4" />
          </video>
        </div>

        <div className="card-talent">
          <a className="title-card-talent" tabIndex={15}>
            Dúvidas Frequentes
          </a>
          <button
            style={{ border: "none", backgroundColor: "white" }}
            title="Baixar pdf Dúvidas Frequentes"
            onClick={() =>
              openLink(
                "https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/TALENT%20BRAND%20STORE/Cat%C3%A1logo%20Brand%20Store.pdf"
              )
            }
          >
            <i
              className="bx bx-download"
              style={{ fontSize: 40, cursor: "pointer" }}
              tabIndex={16}
              id="pdf1talent"
            />
          </button>
        </div>

        <div className="card-talent">
          <a className="title-card-talent" tabIndex={17}>
            Orientações
          </a>
          <button
            style={{ border: "none", backgroundColor: "white" }}
            title="Baixar pdf Orientações"
            onClick={() =>
              openLink(
                "https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/TALENT%20BRAND%20STORE/Orienta%C3%A7%C3%B5es.pdf"
              )
            }
          >
            <i
              className="bx bx-download"
              style={{ fontSize: 40, cursor: "pointer" }}
              tabIndex={18}
              id="pdf2talent"
            />
          </button>
        </div> */}

        <div className="card-talent">
          <a className="title-card-talent" tabIndex={19}>
            Política de Troca
          </a>
          <button
            style={{ border: "none", backgroundColor: "white" }}
            title="Baixar pdf Política de Troca"
            onClick={() =>
              openLink(
                "https://s3.us-east-1.amazonaws.com/bucket.aws.private/hall_83778/TALENT%20BRAND%20STORE/POL%C3%8DTICA%20DE%20TROCA.pdf"
              )
            }
          >
            <i
              className="bx bx-download"
              style={{ fontSize: 40, cursor: "pointer" }}
              tabIndex={20}
              id="pdf3talent"
            />
          </button>
        </div>
      </div>
    </section>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

const mapDispatchToProps = function (dispatch) {
  return {
    loadingUserOff: (data) => {
      return dispatch({ type: "LOGIN_NAVIGATION_OFF", data });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TalentBrandStore);
